module.exports = __webpack_public_path__ + "img/fujilogo-p-800.18ea7b68.png";